import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#7df3e1',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
      <svg
          className={classes.svg}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 95 95"
      >
          <path className={classes.path}
                d="M69.66,15.75l-11.2-4.49c-1.47-.73-3.19-.8-4.71-.18l-28.59,11.76v13.01l-15.17,6.24v24.89l11.55,4.67v-24.9l3.62-1.49v28.14l11.56,4.66V27.55l28.58-11.78c1.4-.58,2.98-.58,4.38,0l-.02-.02Z"/>
          <path className={classes.path}
                d="M84.98,30.06l-11.74-4.68c-1.34-.53-2.84-.53-4.18,0l-28.54,11.76h-.04s0,42.54,0,42.54l11.55,4.66v-42.49l28.58-11.78c1.4-.59,2.98-.59,4.39,0l-.02-.02Z"/>
          <path className={classes.path}
                d="M79.49,50.66v.59c0,5.61-3.4,10.66-8.6,12.76h0l-8.1,3.25v-9.35l1.51-.61c2.17-.89,3.59-3.01,3.58-5.36v-5.17l3.64-1.46c2.95-1.19,6.31.23,7.5,3.18.28.69.42,1.43.42,2.18h.04Z"/>
      </svg>
  );
};
